module.exports = __webpack_public_path__ + "img/27.272637d9.svg";